module.exports = __webpack_public_path__ + "media/images/icon-bell-3766629647744b8f413e79d5278c61bb.png";